// import ReactApexChart from "react-apexcharts";

const getScoreColor = (score: number): string => {
    if (score >= 70) return "#4CAF50"; // Green
    if (score >= 40) return "#FF9800"; // Orange
    return "#F44336"; // Red
};

const CircleChart = ({ score }: { score: number }) => {
    const size = 70;
    const color = getScoreColor(score);
    const strokeWidth = 8
    const radius = (size - strokeWidth) / 2;
   const circumference = 2 * Math.PI * radius;
   const offset = circumference - (score / 100) * circumference;
    // const chartOptions: ApexCharts.ApexOptions = {
    //     chart: {
    //         height: 80,
    //         width: 80,
    //         type: "radialBar",
    //         toolbar: {
    //             show: false,
    //         },
    //         background: "transparent",
    //     },
    //     plotOptions: {
    //         radialBar: {
    //             hollow: {
    //                 margin: 0,
    //                 size: "60%",
    //                 background: "transparent",
    //             },
    //             track: {
    //                 background: "#e7e7e7",
    //                 strokeWidth: "150%",
    //             },
    //             dataLabels: {
    //                 name: {
    //                     show: false,
    //                 },
    //                 value: {
    //                     offsetY: 8,
    //                     fontSize: "16px",
    //                     fontWeight: 600,
    //                     color: color,
    //                     formatter: function (val: number) {
    //                         return val.toString();
    //                     },
    //                 },
    //             },
    //         },
    //     },
    //     fill: {
    //         type: "gradient",
    //         gradient: {
    //             shade: "dark",
    //             type: "horizontal",
    //             shadeIntensity: 0.5,
    //             gradientToColors: [color],
    //             inverseColors: false,
    //             opacityFrom: 1,
    //             opacityTo: 1,
    //             stops: [0, 100],
    //         },
    //     },
    //     stroke: {
    //         lineCap: "round",
    //         colors: [color],
    //         width: 4,
    //     },
    //     colors: [color],
    //     series: [score],
    //     labels: [""],
    // };

    // return <ReactApexChart options={chartOptions} series={chartOptions.series} type="radialBar" height={80} width={80} />;

    return (
        <div style={{ width: 70, height: 70 }}>
        <svg width={size} height={size}>
          <circle
            stroke="#f0f0f5"
            fill="transparent"
            strokeWidth={strokeWidth}
            r={radius}
            cx={size / 2}
            cy={size / 2}
          />
          <circle
            stroke={color}
            fill="transparent"
            strokeWidth={strokeWidth}
            strokeLinecap="round"
            strokeDasharray={circumference}
            strokeDashoffset={offset}
            r={radius}
            cx={size / 2}
            cy={size / 2}
            transform={`rotate(-90 ${size / 2} ${size / 2})`}
          />
          <text
            x="50%"
            y="50%"
            textAnchor="middle"
            dominantBaseline="central"
            fontSize="20"
            fontWeight="bold"
            fill={color}
          >
            {score}
          </text>
        </svg>
      </div>
    );
};

export default CircleChart;